import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { TextInput, TextInputProps } from '@any-ui-react/core';

import { AddressPart } from '@anyx/shared-utils';

import { useAddressFormContext } from '../context';

export type CityFieldProps = Partial<TextInputProps>;

export const CityField = ({ ...rest }: CityFieldProps) => {
  const { t } = useTranslation('shared');
  const { register, getFieldState } = useFormContext();
  const { mappings } = useAddressFormContext();

  const fieldName = mappings[AddressPart.CITY];
  if (!fieldName) {
    return;
  }

  return (
    <TextInput
      {...register(fieldName)}
      label={t('shared.field.cityName.name', { ns: 'shared' })}
      placeholder={t('shared.field.cityName.placeholder', { ns: 'shared' })}
      required
      error={getFieldState(fieldName)?.error?.message?.toString()}
      {...rest}
    />
  );
};
